import { render } from "./BtnGroupX.vue?vue&type=template&id=4e193f6c&scoped=true"
import script from "./BtnGroupX.vue?vue&type=script&lang=js"
export * from "./BtnGroupX.vue?vue&type=script&lang=js"

import "./BtnGroupX.vue?vue&type=style&index=0&id=4e193f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e193f6c"]])

export default __exports__